import { getPlan } from "./plan";

export const isBinary = () => getPlan() === "UNILEVEL";
export const isNotBinary = () => !isBinary();
